import constants from 'jsx/common/constants';
import { useAllAssetsText } from './utils';

export const preTriggerStoreCleanup = (trigger: any) => {
  /*
  Will cleanup the automation object for storage.
  This is done in the latest stage so the values are not removed recursively
  from the orignal object.

  Example: We don't want to send temp variables to the backend. But we do want
  to keep the state in the frontend so the form wil not change.
   */
  if (trigger.settings) delete trigger.settings.temp;
};

export const preConditionsStoreCleanup = (conditions: any) => {
  /*
  Will cleanup the automation object for storage.
  This is done in the latest stage so the values are not removed recursively
  from the orignal object.

  Example: We don't want to send temp variables to the backend. But we do want
  to keep the state in the frontend so the form wil not change.
   */
  if (Array.isArray(conditions.conditions)) {
    conditions.conditions.forEach((c: any) => {
      Array.isArray(c) ? preConditionsStoreCleanup(c) : delete c.settings.temp;
    });
  }
};

export const recursiveCleanup = (conditions: any) => {
  if (Array.isArray(conditions)) {
    conditions.forEach(c => {
      if (c.settings.asset_id === useAllAssetsText) c.settings.asset_id = '';
      if (c.settings.custodian === 'empty') c.settings.custodian = '';
      if (
        c.conditions === null ||
        (Array.isArray(c.conditions) && c.conditions.length === 0)
      )
        delete c.conditions;
      if (c.type === constants.automation.types.condition.CONDITIONS_AND) {
        c.type = 'CONDITIONS';
        c.operator = 'AND';
      }
      if (c.type === constants.automation.types.condition.CONDITIONS_OR) {
        c.type = 'CONDITIONS';
        c.operator = 'OR';
      }
    });
  }
};
export const cleanEmptyConditions = (conditions: any) =>
  conditions.filter(
    (x: any) => !(x.type === 'CONDITIONS' && !x.conditions?.length)
  );
const filterTempKey = (obj: any) => {
  const { temp, ...remainder } = obj;
  return remainder;
};
export const cleanConditionTempSettings = (conditions: any) =>
  conditions.map((x: any) => ({
    ...x,
    conditions:
      x.conditions && x.conditions.length
        ? cleanConditionTempSettings(x.conditions)
        : [],
    settings: filterTempKey(x.settings),
  }));

const serviceNowFields = [
  'title',
  'servicenow_config_id',
  'servicenow_data',
  'asset_id',
  'send_custodian_email',
  'send_custom_email',
  'custom_email',
  'description',
];

const actionServiceSettingsFields = {
  'alert.create': [
    'title',
    'message',
    'priority',
    'custodian',
    'asset_id',
    'send_custodian_email',
    'send_custom_email',
    'custom_email',
  ],
  'alert.servicenow': serviceNowFields,
  'alert.servicenow.case': serviceNowFields,
  email: [
    'title',
    'message',
    'custodian',
    'send_custodian_email',
    'send_custom_email',
    'custom_email',
  ],
};

const getSettings = (settings: { service: any }) =>
  actionServiceSettingsFields[
    settings.service as keyof typeof actionServiceSettingsFields
  ] || [];

export const cleanActionSettings = (settings: any) =>
  Object.assign(
    { service: settings.service },
    ...getSettings(settings).map((x: any) => ({ [x]: settings[x] }))
  );

export const cleanActions = (actions: any) =>
  (actions || []).map((x: any) => ({
    ...x,
    settings: cleanActionSettings(x.settings),
  }));
